import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  color: "#869DF0",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.317 9.317 8.283 6.283a.4.4 0 0 0-.566 0L4.683 9.317a.4.4 0 0 0 .283.683h6.068a.4.4 0 0 0 .283-.683"
    }, null, -1)
  ]))]))
}
export default { render: render }